var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13672 3.89724C1.13672 3.25546 1.32703 2.6281 1.68358 2.09447C2.04014 1.56085 2.54692 1.14495 3.13985 0.899348C3.73278 0.65375 4.38522 0.58949 5.01466 0.714695C5.64411 0.8399 6.2223 1.14895 6.67611 1.60275C7.12991 2.05656 7.43896 2.63475 7.56416 3.26420C7.68937 3.89364 7.62511 4.54608 7.37951 5.13901C7.13391 5.73194 6.71801 6.23872 6.18439 6.59528C5.65076 6.95183 5.02340 7.14214 4.38162 7.14214V9.30541",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.4, 12)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38026 0.550781C2.05937 0.550781 1.74569 0.645937 1.47888 0.824214C1.21207 1.00249 1.00411 1.25588 0.881315 1.55235C0.758515 1.84881 0.726386 2.17503 0.788988 2.48975C0.851591 2.80448 1.00611 3.09357 1.23302 3.32047C1.45992 3.54738 1.74901 3.7019 2.06374 3.7645C2.37846 3.82711 2.70468 3.79498 3.00115 3.67218C3.29761 3.54938 3.551 3.34142 3.72928 3.07461C3.90756 2.8078 4.00271 2.49412 4.00271 2.17323C3.99711 1.74467 3.82437 1.33524 3.52131 1.03218C3.21825 0.72912 2.80882 0.556384 2.38026 0.550781Z",
    fill: "#667085"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.1283956fcb37b83c679387369098b49b.svg";
export { ForwardRef as ReactComponent };